/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyerChatLazy_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChat_viewer">;
    readonly " $refType": "BuyerChatLazy_viewer";
};
export type BuyerChatLazy_viewer$data = BuyerChatLazy_viewer;
export type BuyerChatLazy_viewer$key = {
    readonly " $data"?: BuyerChatLazy_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatLazy_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuyerChatLazy_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BuyerChat_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '471e110b00cc367a9ca8ad61d83841f3';
export default node;
